import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

import instagram_square from '../../../assets/img/instagram-square.png';

class RealEstate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Real Estate </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                    Thanks to new XR technologies, all you have to do is put a VR headset 
                    on and get yourself immersed into another reality. All the perks of an 
                    open house without the need to attend one. Real estate companies see huge 
                    potential in the use of both VR and AR. While Virtual Reality can serve as 
                    an alternative to open house, Augmented Reality might help potential customers 
                    visualize their for-now-empty-homes with furniture and decor.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      Virtual viewing can help both real estate agents and home buyers feel 
                      so much more confident about buying (or in Rentberry’s case, renting) sights unseen.
                      And that’s important because according to Redfin, 1 in 3 home buyers 
                      make their offers without ever seeing the property in real life.
                      <br></br> 
                      That’s up from barely 1 in 5 just one year ago.
                      These days, 95% of buyers use the internet to look for homes, and 51% buy 
                      homes that they have found using the internet.
                      On top of that, NAR’s 2017 study found that only buyers over the age of 71 
                      are contacting a Realtor before looking online. Compare that to the 71% of 
                      millennials who are excited about VR and the math just makes sense.
                      <br></br> 
                      VR and AR technologies are literally the future, even in a people business like real estate.
                      And that’s really a wonderful thing. VR and AR tech can help agents make a 
                      stellar first impression with both home buyers and sellers, solve common communication 
                      challenges with prospects, and even help agents spend their time more wisely by not 
                      taking buyers to view properties you know they won’t like.
                      All of which will result in closing more deals in less time.
                      <br></br> 
                      Have you ever wondered how this technology can assist in a seemingly unrelated domain 
                      like architecture? Well, it is possible. AbilitàXR has the power to transform 
                      bland architect models and renderings into unique, refreshingly immersive experiences 
                      for the decision-makers. We get a better sense of how individual components would look, 
                      feel, interact, and function in a finished residential or commercial property.
                      The buyer doesn’t need to visit the property physically. We can choose the one they 
                      like by touring them virtually. Within a matter of minutes, the buyer can have a 360-degree 
                      view of the interiors, exteriors, surrounding areas, and 3D walkthroughs of different properties. 
                      This way, with VR, he can make a decision whether to buy the property or not.
                    </h6>

                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
              {/* -------------- Footer Start -------- */}
                <Row className="mt-5">
                </Row>
                <Row className="pt-5 pb-5 home-background-gray">
                  <Col xs="0" sm="0" lg="1">
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "ml-2 text-left">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>PRODUCT</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                         <a href = "/feature"><div className = "font-size-10" >Features</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/appguide"><div className = "font-size-10" >App Guide</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <div className = "font-size-10" >Platform Guide</div>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "/customdev"><div className = "font-size-10" >Custom Development</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <div className = "font-size-10" >Pricing</div>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "https://goo.gl/1s6PZH" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" >Get VR Headset</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div >USE CASES</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/realestate"><div className = "font-size-10" >Real Estate</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/architecture"><div className = "font-size-10" >Architecture</div></a>
                      </Col>
                      <Col className = "mb-2  text-secondary" md = '12'> 
                        <a href = "/medical"><div className = "font-size-10" >Medical</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/retail"><div className = "font-size-10" >Retail</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/sports"><div className = "font-size-10" >Sports</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/media"><div className = "font-size-10" >Media</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/travel"><div className = "font-size-10" >Travel</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/education"><div className = "font-size-10" >Education</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/training"><div className = "font-size-10" >Training</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/ecommerce"><div className = "font-size-10" >Ecommerce</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/entertainment"><div className = "font-size-10" >Entertainment</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>Support</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "http://www.icomputinglabs.in/blog/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" >Blog</div> </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/faq"><div className = "font-size-10" >FAQ</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/contact"><div className = "font-size-10" >Contact</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>COMPANY</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/about"><div className = "font-size-10" >About</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/privacy"><div className = "font-size-10" >Privacy Policy</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/tos"><div className = "font-size-10" >Terms of Service</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>GET CONNECTED</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.facebook.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-facebook-square fa-lg mr-2" />facebook</div>
                        </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.instagram.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><img  alt="" src={instagram_square} className = "text-primary width-16 mr-2" />instagram</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "https://twitter.com/iComputingLabs" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-twitter-square fa-lg mr-2" />twitter</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'>
                        <a href = "https://www.linkedin.com/company/13404850/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-linkedin-square fa-lg mr-2" />linkedin</div>
                        </a>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              {/* -------------- Footer End -------- */}
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default RealEstate;



// WEBPACK FOOTER //
// ./src/views/Pages/RealEstate/RealEstate.js